import { render, staticRenderFns } from "./b-classify-customer.pug?vue&type=template&id=46d81b7a&lang=pug&"
import script from "./b-classify-customer.ts?vue&type=script&lang=ts&"
export * from "./b-classify-customer.ts?vue&type=script&lang=ts&"
import style0 from "./b-classify-customer.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports